import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    adminInfo: {
        paddingLeft: '8px',
    },
    adminName: {
        paddingLeft: '4px',
        textDecoration: 'underline',
    },
    tabsContainer: {
        height: '66px',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '16px',
    },
}));
